<template>
  <q-btn-dropdown
    ref="dropdown"
    v-bind="$attrs"
    align="between"
    content-class="bg-responsive"
    content-style="max-height: 300px"
    :persistent="!!geoapifyEnabled"
    data-test-id="site-selector-zones-selectbox"
  >
    <template
      #label
    >
      <div class="row items-center no-wrap ">
        <q-icon
          v-if="!hideIcon"
          class="q-px-none"
          left
          name="fal fa-location-dot"
        />
        <div
          class="text-left ellipsis"
        >
          <template v-if="$_.isEmpty(selectedLocations)">
            {{ currentSite.displayName }}
          </template>
          <template v-else>
            <template
              v-for="(location, index) in selectedLocations"
              :key="location.id"
            >
              {{ index !== selectedLocations.length - 1 ? `${location.name}, ` : location.name }}
            </template>
          </template>
        </div>
      </div>
    </template>
    <div>
      <q-list bordered>
        <site-location-look-up
          :redirect-home-page="redirectHomePage"
          :is-widget="isWidget"
          dropdown-list-view
          hide-address
          dense
          :navigate-on-select="navigateOnSelect"
          @all-locations-shown="shown => showAllLocation = shown"
          @loading="value => loading = value"
        />
      </q-list>
      <template v-if="showAllLocation">
        <site-selector-locations-list
          :sites-without-location-zone-id="sitesWithoutLocationZoneId"
          :location-zones="locationZones"
          :site-locations="siteLocations"
          :redirect-home-page="redirectHomePage"
          :navigate-on-select="navigateOnSelect"
          :selected-locations="selectedLocations"
          default-opened
          dropdown-list-view
          hide-address
          bordered
          @select-location="(site, action) => handleLocationSelect(site, action)"
        />
      </template>
    </div>
  </q-btn-dropdown>
</template>

<script>
import { geoapifyEnabled } from 'src/config'
import SiteLocationsListMixin from 'src/modules/consumer/components/mixins/SiteLocationsListMixin'
import SiteLocationLookUp from 'src/modules/consumer/components/site-selector/SiteLocationLookUp'
import SiteSelectorLocationsList from 'src/modules/consumer/components/site-selector/SiteSelectorLocationsList'
export default {
  name: 'SiteSelectorZonesSelectbox',
  components: {
    SiteSelectorLocationsList,
    SiteLocationLookUp
  },
  mixins: [SiteLocationsListMixin],
  props: {
    compactView: {
      type: Boolean,
      required: false,
      default: false
    },
    redirectHomePage: {
      type: Boolean,
      required: false,
      default: false
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    isWidget: {
      type: Boolean,
      required: false,
      default: false
    },
    navigateOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    filteredLocationsIds: {
      type: Array,
      required: false,
      default: () => []
    },
    multipleSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    flattenZoneGroups: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['select-location'],
  data () {
    return {
      showAllLocation: true,
      selectedLocations: []
    }
  },
  watch: {
    filteredLocationsIds: {
      immediate: true,
      handler (newVal) {
        if (newVal && !_.isEmpty(newVal)) {
          this.selectedLocations = _.filter(this.sites.data, site => _.includes(newVal, site.id))
        }
      }
    }
  },
  created () {
    _.extend(this, {
      geoapifyEnabled
    })
  },
  methods: {
    handleLocationSelect (site, action) {
      // Emit the select-location event
      this.$emit('select-location', site, action)

      if (this.multipleSelection) return

      // Close the dropdown after selection when single selection
      this.$nextTick(() => {
        if (this.$refs.dropdown) {
          this.$refs.dropdown.hide()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.q-btn-dropdown__arrow) {
 font-size: 0.8em;
}
</style>
